import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Vault from "@/pages/Vault";
import Insurance from "@/pages/Insurance";
import Investments from "@/pages/Investments";
import Accounts from "@/pages/Accounts";
import Assets from "@/pages/Assets";
import Legal from "@/pages/Legal";
import Family from "@/pages/Family";
import Crisis from "@/pages/Crisis";
import AdvisorDashboard from "@/pages/AdvisorDashboard";
import HealthScore from "@/pages/HealthScore";
import AiChat from "@/pages/AiChat";
import Simulation from "@/pages/Simulation";
import EmergencyAccess from "@/pages/EmergencyAccess";
import Stories from "@/pages/Stories";
import Security from "@/pages/Security";
import Billing from "@/pages/Billing";
import BillingReturn from "@/pages/BillingReturn";
import Investors from "@/pages/Investors";
import PanSnapshot from "@/pages/PanSnapshot";

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/investors" element={<Investors />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/emergency/:token" element={<EmergencyAccess />} />

                        <Route
                            path="/crisis"
                            element={
                                <ProtectedRoute>
                                    <Crisis />
                                </ProtectedRoute>
                            }
                        />

                        <Route
                            element={
                                <ProtectedRoute>
                                    <AppLayout />
                                </ProtectedRoute>
                            }
                        >
                            <Route path="/dashboard" element={<Dashboard />} />
                            <Route path="/vault" element={<Vault />} />
                            <Route path="/stories" element={<Stories />} />
                            <Route path="/insurance" element={<Insurance />} />
                            <Route path="/investments" element={<Investments />} />
                            <Route path="/accounts" element={<Accounts />} />
                            <Route path="/assets" element={<Assets />} />
                            <Route path="/legal" element={<Legal />} />
                            <Route path="/family" element={<Family />} />
                            <Route path="/health-score" element={<HealthScore />} />
                            <Route path="/ai-chat" element={<AiChat />} />
                            <Route path="/simulation" element={<Simulation />} />
                            <Route path="/security" element={<Security />} />
                            <Route path="/pan-snapshot" element={<PanSnapshot />} />
                            <Route path="/billing" element={<Billing />} />
                            <Route path="/billing/return" element={<BillingReturn />} />
                            <Route
                                path="/advisor"
                                element={
                                    <ProtectedRoute requireRole="advisor">
                                        <AdvisorDashboard />
                                    </ProtectedRoute>
                                }
                            />
                        </Route>

                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}

export default App;
